import React, { ReactNode } from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { Trans, useTranslation } from 'react-i18next';
import { Button, InformationBox } from '@app/core';
import classnames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    width: '100%',
    marginTop: theme.marginBase * 7,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.marginBase * 2,
  },
  box: {
    marginTop: theme.marginBase,
    marginBottom: theme.marginBase * 2,
  },
  btnReadContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  subTitle: {
    marginTop: theme.marginBase * 3,
    ...theme.fonts.h4,
  },
}));

interface Props {
  title: ReactNode;
  help?: ReactNode;
  children?: ReactNode;
  className?: string;
}

export const LinkConfigurationCheckSection = ({
  title,
  help,
  children,
  className,
}: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classnames(classes.container, className)}>
      <div className={classes.subTitle}>{title}</div>
      {help && (
        <InformationBox variant="info" className={classes.box}>
          {help}
          <div className={classes.btnReadContainer}>
            <Button
              text={t('editSession.screening.helpInformation.read')}
              variant="muted"
              small
              rel="noopener noreferrer"
              target="_blank"
              href={t(
                'editSession.linkConfiguration.studyLinkConfiguration.linkHelp',
              )}
            />
          </div>
        </InformationBox>
      )}
      {children}
    </div>
  );
};
